var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLayoutTileview = function SvgLayoutTileview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.143.286A6.857 6.857 0 0 0 .286 7.143v13.714a6.857 6.857 0 0 0 6.857 6.857h13.714a6.857 6.857 0 0 0 6.857-6.857V7.143A6.857 6.857 0 0 0 20.857.286H7.143ZM20.857 2.57h-5.714v10.286h10.285V7.143a4.571 4.571 0 0 0-4.57-4.572Zm4.572 12.572H15.143v10.285h5.714a4.571 4.571 0 0 0 4.572-4.57v-5.715Zm-12.572-2.286V2.571H7.143A4.571 4.571 0 0 0 2.57 7.143v5.714h10.286ZM2.571 15.143v5.714a4.571 4.571 0 0 0 4.572 4.572h5.714V15.143H2.571Z",
    fill: "#73777A"
  })));
};
export default SvgLayoutTileview;